import { OnePager } from "../libs/components/simpleonepager/OnePager";
import { useDAppCommand } from "../libs/dweb/DAppCommand";
import { PageHeaderMenu } from "../libs/dweb/DPageHeaderMenu";


export function LandingPage() {
  let appCommand = useDAppCommand()
  return (
    <OnePager
      extraElement={
        <PageHeaderMenu
          hideSignInButton={true}
          logo={require("./asserts/img/logo.png")}
          rightDropDownActions={[{ text: "dashboard", href: "/dashboard" }]}
          style={{ backgroundColor: "#00000000" }}
        />
      }
      config={{
        theme: { backgroundColor: '#000000' },
        hero_section: {
          hero_title: "Grodok™  – Your Partner in Building Great Products",
          hero_subtitle: "At Grodok, we transform ideas into reality. Whether you're a startup or an enterprise, our expert team helps you design, develop, and launch scalable software solutions tailored to your needs.",
          hero_image_src: "",
          primary_btn_link: "mailto:hello@grodok.com",
          primary_btn_subtext: "(To know more,  mail to hellp@grodok.com)",
          primary_btn_title: "Mail to hello@grodok.com",
        },
        generic_section: [
          {
            groupOfThree: [
              {
                title: "✅ Custom Software Development & Technical Consulting ",
                subtitle: "Web, mobile, and desktop applications built to solve real-world problems.  Expert guidance to refine your architecture, improve performance, and scale seamlessly.",
                btn_text: "Know more",
                btn_link: "",
              },
              {
                title: "✅ Cutting Edge tech including AI & Machine Learning ",
                subtitle: "Leverage AI to enhance user experiences and business intelligence. Our machine learning models help you make data-driven decisions and automate repetitive tasks.",
                btn_text: "Learn more",
                btn_link: "",
              },
              {
                title: "✅ Product Development & Cloud & DevOps",
                subtitle:
                  "Build-in support for logging, analytics, crash logs and SEV Managers. We help you build, deploy, and scale your product on the cloud with our DevOps expertise.",
                btn_text: "Learn more",
                btn_link: "",
              },
            ],
          },

          {

            groupOfThree: [
              {
                title: "🔹 Expert Engineers ",
                subtitle: "A dedicated team with experience in cutting-edge technologies. Our engineers are experts in their fields and are committed to delivering high-quality solutions.",
                btn_text: "Know more",
                btn_link: "",

              },
              {
                title: "🔹 End-to-End Support ",
                subtitle: "From planning to post-launch, we are with you at every step. Our team provides continuous support and maintenance to ensure your product runs smoothly.",
                btn_text: "Learn more",
                btn_link: "",

              },
              {
                title: "🔹 On-Time Delivery ",
                subtitle:
                  "Agile processes ensure we deliver high-quality solutions on schedule. Our team is committed to meeting deadlines and ensuring your product is launched on time.",
                btn_text: "Learn more",
                btn_link: "",
              },
            ],
          },
        ],
        footer_section: {
          author_email: "hello@grodok.com",
          author_text: "Grodok Technologies",
          author_link: "/",
          privacy_link: "/",
          toc_link: "/",
        },
      }}
    />
  );
}
